import { Body, bodyVariants } from '@/components/body';
import { Heading } from '@/components/heading';
import { cn } from '@/lib/utils';
import { ReactNode } from 'react';

export default function SectionCard({
  icon,
  title,
  text,
  className,
  style,
}: {
  icon: ReactNode;
  title: string;
  text: ReactNode | ReactNode[] | string | string[];
  className?: string | undefined;
  style?: React.CSSProperties;
}) {
  return (
    <div
      className={cn(
        'bg-background-2 flex flex-col justify-start rounded-2xl p-8 gap-8',
        className,
      )}
      style={style}
    >
      {icon}
      <div className="flex flex-col gap-4">
        <Heading variant="h4">{title}</Heading>
        {Array.isArray(text) ? (
          <ul className="list-none flex flex-col gap-2">
            {text.map((line, index) => (
              <li key={index} className={bodyVariants({ variant: 'large' })}>
                {line}
              </li>
            ))}
          </ul>
        ) : (
          <Body variant="large">{text}</Body>
        )}
      </div>
    </div>
  );
}